export default __webpack_public_path__ + "static/media/github.3b21c250.svg";